import { graphql } from "../../gql";
import { useMutation } from "@apollo/client";
import {
  BusinessEnglishObjective,
  OneOnOneLessonType,
} from "../../gql/graphql.ts";
import { useCallback } from "react";

const UpdateUser1on1ClassroomPlanLessonTypeMutation = graphql(`
  mutation updateUser1on1ClassroomPlanLessonType(
    $id: String!
    $oneOnOneLessonType: OneOnOneLessonType!
    $businessEnglishObjective: BusinessEnglishObjective
  ) {
    updateUser1on1ClassroomPlanLessonType(
      id: $id
      oneOnOneLessonType: $oneOnOneLessonType
      businessEnglishObjective: $businessEnglishObjective
    ) {
      ...UserOneOnOneClassroomPlan
    }
  }
`);

export function useUpdateUser1on1ClassroomPlanLessonType() {
  const [mutate, { loading }] = useMutation(
    UpdateUser1on1ClassroomPlanLessonTypeMutation,
  );

  const updateLessonType = useCallback(
    async (
      id: string,
      oneOnOneLessonType: OneOnOneLessonType,
      businessEnglishObjective?: BusinessEnglishObjective,
    ) => {
      await mutate({
        variables: { id, oneOnOneLessonType, businessEnglishObjective },
      });
    },
    [mutate],
  );

  return { updateLessonType, loading };
}
